export default {"src":"/_next/static/media/constructor.16622aac.svg","height":29,"width":25,"blurWidth":0,"blurHeight":0};